import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { applyVulnerabilityDataAtom } from '@app/risk-migration/atoms/riskLayers.atoms'
import {
  drawAreasAtom,
  nonEmptyElementFiltersAtom,
  regionMasksAtom,
} from '@app/risk-migration/atoms/riskFilters.atoms'
import { useRiskLayersState } from '@app/risk-migration/hooks/useRiskLayersState'
import { useVulnerabilityStats } from './useVulnerabilityStats'
import { cascadingAssetNDaysAtom } from '@app/risk-migration/atoms/riskMap.atoms'
export function useCurrentVulnerabilityData() {
  const cascadingAssetNDays = useAtomValue(cascadingAssetNDaysAtom)
  const { layers } = useRiskLayersState()

  const drawAreas = useAtomValue(drawAreasAtom)
  const regionMasks = useAtomValue(regionMasksAtom)
  const elementFilters = useAtomValue(nonEmptyElementFiltersAtom)
  const applyVulnerabilityData = useAtomValue(applyVulnerabilityDataAtom)

  const clientName = localStorage.getItem('client_name')

  const { assetLayers, hazardLayers } = useMemo(() => {
    return {
      assetLayers: layers.filter((layer) => layer.layerType === 'asset'),
      hazardLayers: layers.filter((layer) => layer.layerType === 'hazard'),
    }
  }, [layers])

  const { data: vulnerabilityData, isFetching: vulnerabilityLoading } = useVulnerabilityStats({
    assetLayers,
    hazardLayers,
    drawAreas,
    regionMasks,
    elementFilters,
    cascadingAssetNDays,
    clientName,
    enabled: applyVulnerabilityData,
  })

  return {
    vulnerabilityData,
    vulnerabilityLoading,
  }
}
